import axiosCoralie from "../axios-setup";

const CONF = window?.confPub;
const TECHNIQUE_EDCL_ROUTES = CONF?.ROUTES?.TECHNIQUE_EDCL

export const envoiTrace = async (idGrm, action, infos) => {

    const ENVOI_TRACE = TECHNIQUE_EDCL_ROUTES?.ENVOI_TRACE

    try {

        const resp = await axiosCoralie.post(ENVOI_TRACE, {
            idGrm: idGrm,
            action: action,
            infos: infos,
        })

    } catch (err) {

        console.log("err", err)
    }
}